export default function (path: string): string {
	const url = import.meta.env.VITE_CDN_URL;

	return `${url}/${path}`;
}
